export default __webpack_public_path__ + "static/media/logoExtended.d4a231e6.png";